module.exports = __webpack_public_path__ + "static/media/reports.c4f02949.svg";